import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwdss8q3: FaireProductEntity = {
  token: "p_bwdss8q3",
  type: "product",
  name: "Aloha 'Aina \u2013 Hibiscus Passion Pure Bar Soap",
  brandName: "Maui Soap Co.",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b7719d517668e3adc8e0df1c9b8aa02893a08163e0b3b6ab2df22288140f8a5e/1563995283.jpg",
  priceDollars: 5.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ee1378d94a9220e554cca56ac44acb6f8e5ddfdc181707cca100cc1e982a605f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
